import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const MenuItemCard = ({ item, onEdit, onToggleAvailability, onDelete }) => {
  const [imageError, setImageError] = useState(false);

  return (
    <div className="bg-card rounded-xl shadow-warm overflow-hidden transition-smooth hover:shadow-warm-md">
      <div className="relative h-40 md:h-48 overflow-hidden">
        <Image
          src={item?.image}
          alt={item?.imageAlt}
          className="w-full h-full object-cover"
          onError={() => setImageError(true)}
        />
        <div className="absolute top-3 right-3 flex gap-2">
          {item?.isNew && (
            <span className="px-3 py-1 bg-accent text-accent-foreground text-xs font-bold rounded-full">
              NEW
            </span>
          )}
          <button
            onClick={() => onToggleAvailability(item?.id)}
            className={`px-3 py-1 rounded-full text-xs font-bold transition-smooth ${
              item?.is_available
                ? 'bg-success text-success-foreground'
                : 'bg-muted text-muted-foreground'
            }`}
          >
            {item?.is_available ? 'Available' : 'Unavailable'}
          </button>
        </div>
      </div>
      <div className="p-4">
        <div className="flex items-start justify-between gap-2 mb-2">
          <h4 className="font-heading font-semibold text-base md:text-lg text-foreground line-clamp-1">
            {item?.name}
          </h4>
          <p className="text-lg md:text-xl font-heading font-bold text-primary data-text flex-shrink-0">
            ${Number(item?.price_per_plate ?? item?.price ?? 0).toFixed(2)}
          </p>
        </div>

        <p className="text-sm text-muted-foreground line-clamp-2 mb-3">
          {item?.description}
        </p>

        <div className="flex flex-wrap gap-2 mb-4">
          <span className="px-2 py-1 bg-primary/10 text-primary text-xs font-caption rounded-md">
            {item?.cuisine}
          </span>
          {item?.dietary?.map((diet, index) => (
            <span key={index} className="px-2 py-1 bg-success/10 text-success text-xs font-caption rounded-md flex items-center gap-1">
              <Icon name="Leaf" size={12} />
              {diet}
            </span>
          ))}
        </div>

        <div className="flex items-center justify-between text-xs md:text-sm text-muted-foreground mb-4">
          <div className="flex items-center gap-1.5">
            <Icon name="Star" size={14} color="var(--color-warning)" />
            <span className="font-semibold data-text">{item?.rating}</span>
            <span>({item?.reviews})</span>
          </div>
          <div className="flex items-center gap-1.5">
            <Icon name="ShoppingBag" size={14} />
            <span className="data-text">{item?.ordersCount} orders</span>
          </div>
        </div>

        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            fullWidth
            iconName="Edit"
            iconPosition="left"
            onClick={() => onEdit(item?.id)}
          >
            Edit
          </Button>
          <Button
            variant="ghost"
            size="sm"
            iconName="Trash2"
            onClick={() => onDelete(item?.id)}
            className="text-error hover:bg-error/10"
          />
        </div>
      </div>
    </div>
  );
};

export default MenuItemCard;